import { render } from "./VersieControle.vue?vue&type=template&id=57abd58a"
import script from "./VersieControle.vue?vue&type=script&lang=js"
export * from "./VersieControle.vue?vue&type=script&lang=js"

import "./VersieControle.vue?vue&type=style&index=0&id=57abd58a&lang=css"
script.render = render

export default script